export const IgPosts = [
  {
    id: 1,
    url: "https://www.instagram.com/canterburyschools/",
  },
  // {
  //   id: 2,
  //   url: "https://www.instagram.com/p/POST_ID_2/",
  // },
  // {
  //   id: 3,
  //   url: "https://www.instagram.com/p/POST_ID_3/",
  // },
];
